var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewleads(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8334 8.00016H12.8334L11.1667 10.5002H7.83335L6.16669 8.00016H1.16669M17.8334 8.00016V13.0002C17.8334 13.4422 17.6578 13.8661 17.3452 14.1787C17.0326 14.4912 16.6087 14.6668 16.1667 14.6668H2.83335C2.39133 14.6668 1.9674 14.4912 1.65484 14.1787C1.34228 13.8661 1.16669 13.4422 1.16669 13.0002V8.00016M17.8334 8.00016L14.9584 2.2585C14.8204 1.98082 14.6077 1.74714 14.3442 1.58373C14.0806 1.42032 13.7768 1.33366 13.4667 1.3335H5.53335C5.22328 1.33366 4.91941 1.42032 4.65589 1.58373C4.39237 1.74714 4.17967 1.98082 4.04169 2.2585L1.16669 8.00016",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewleads);
export default __webpack_public_path__ + "static/media/newleads.49d51dad864b9a96b9bef4f21d8b5e30.svg";
export { ForwardRef as ReactComponent };